"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteProposal = void 0;
const react_1 = require("@apollo/client/react");
const delete_proposal_mutation_1 = require("../delete-proposal.mutation");
const useDeleteProposal = () => {
    const [deleteProposal, data] = (0, react_1.useMutation)(delete_proposal_mutation_1.DELETE_PROPOSAL);
    return Object.assign({ deleteProposal }, data);
};
exports.useDeleteProposal = useDeleteProposal;
exports.default = exports.useDeleteProposal;
